/* Foersterin Anne mit Sprechblase (snippets/pt-anne-say.liquid). ES5. Claude 25.10.2026
   Beim Hineinscrollen: Anne kommt hoch, Blase ploppt auf, Text erscheint Wort fuer Wort, danach kurz leichtes Atmen.
   Clip (pt-anne-wave.mp4) spielt einmal und bleibt auf dem letzten Bild. prefers-reduced-motion: alles statisch. */
(function () {
  var d = document, root = d.documentElement;
  var els = d.querySelectorAll("[data-pta2]");
  window.PTAnneSay = { n: els.length };
  if (!els.length) return;
  var reduce = false;
  try { reduce = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e) {}
  if (reduce) root.className += " pta2-rm";

  function words(el) {
    /* Textknoten in Wort-Spans zerlegen (Tags wie <b> bleiben erhalten) */
    var n = 0;
    function walk(node) {
      var kids = [], i;
      for (i = 0; i < node.childNodes.length; i++) kids.push(node.childNodes[i]);
      for (i = 0; i < kids.length; i++) {
        var k = kids[i];
        if (k.nodeType === 3) {
          var parts = k.nodeValue.split(/([ \t\n\r]+)/), frag = d.createDocumentFragment();
          for (var j = 0; j < parts.length; j++) {
            if (!parts[j]) continue;
            if (/^[ \t\n\r]+$/.test(parts[j])) { frag.appendChild(d.createTextNode(parts[j])); continue; }
            var s = d.createElement("span");
            s.className = "pta2-w";
            s.style.transitionDelay = Math.min(0.5 + n * 0.05, 1.7).toFixed(2) + "s";
            s.appendChild(d.createTextNode(parts[j]));
            frag.appendChild(s); n++;
          }
          node.replaceChild(frag, k);
        } else if (k.nodeType === 1) walk(k);
      }
    }
    walk(el);
  }

  function playVid(box) {
    var v = box.querySelector("video[data-pta2-src]");
    if (!v || reduce) return;
    var src = v.getAttribute("data-pta2-src");
    v.removeAttribute("data-pta2-src");
    v.muted = true;
    v.setAttribute("muted", "");
    v.setAttribute("playsinline", "");
    v.addEventListener("playing", function () { box.className += " pta2-playing"; }, false);
    v.src = src;
    try {
      var p = v.play();
      if (p && p["catch"]) p["catch"](function () {});
    } catch (e) {}
  }

  function show(box) {
    if (box.getAttribute("data-pta2-in")) return;
    box.setAttribute("data-pta2-in", "1");
    box.className += " is-in";
    setTimeout(function () { playVid(box); }, 450);
  }

  var i;
  for (i = 0; i < els.length; i++) {
    var t = els[i].querySelector(".pta2-t");
    if (t && !reduce) { try { words(t); } catch (e) {} }
  }

  if (reduce || !("IntersectionObserver" in window)) {
    for (i = 0; i < els.length; i++) show(els[i]);
    return;
  }
  var io = new IntersectionObserver(function (list) {
    for (var k = 0; k < list.length; k++) {
      if (list[k].isIntersecting) { show(list[k].target); io.unobserve(list[k].target); }
    }
  }, { rootMargin: "0px 0px -18% 0px", threshold: 0.15 });
  for (i = 0; i < els.length; i++) io.observe(els[i]);
})();
